// کلید Idempotency یک فرم ثبت (C-AGENT-133، C-AGENT-203): همان کلید برای تکرار پس از خطای شبکه (پاسخی نرسیده)؛ پس از هر
// پاسخ سرور (موفق یا خطا) کلید تازه تا ارسال دوباره با بدنه اصلاح‌شده PHX-GEN-0008 نگیرد.
import { isApiError } from '@phoenix/api-client';
import { useCallback, useRef } from 'react';

export function useIdempotencyKey() {
  const key = useRef<string>(crypto.randomUUID());
  const current = useCallback(() => key.current, []);
  const settle = useCallback((error?: unknown) => {
    const noResponse = isApiError(error) && error.status === 0;
    if (!noResponse) {
      key.current = crypto.randomUUID();
    }
  }, []);
  return { current, settle };
}
